<template>
  <AlertLayout
    title="Why Set Up your Inventory and Cost?"
    message="Setting up inventory costs helps you track expenses, manage stock efficiently and ensure accurate pricing for your facility."
    type="warning"
  />
  <div
    class="overflow-hidden flex flex-wrap items-center justify-between pb-4 py-1"
  >
    <div class="flex items-center space-x-4 w-full">
      <div class="p-2 overflow-y-auto w-full">
        <div>
          <!-- Tabs -->
          <div class="mb-4 border-b">
            <ul class="flex flex-wrap -mb-px w-full">
              <li v-for="tab in tabs" :key="tab.name" class="mr-2">
                <a
                  href="#"
                  @click.prevent="currentTab = tab.component"
                  :class="[
                    'inline-block p-4 rounded-t-lg',
                    currentTab === tab.component
                      ? 'border-b-2 border-custom-yellow text-custom-blue'
                      : 'hover:text-gray-600 hover:border-gray-300',
                  ]"
                >
                  {{ tab.name }}
                </a>
              </li>
            </ul>
          </div>

          <!-- Tab content -->
          <component
            :is="currentTab"
            :prescriptionDetails="prescriptionDetails"
          ></component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PharmaceuticalFormTab from "@/views/tabs/inventory_tabs/PharmaceuticalFormTab.vue";
import NonPharmaceuticalFormTab from "@/views/tabs/inventory_tabs/NonPharmaceuticalFormTab.vue";
import AlertLayout from "@/components/AlertLayout.vue";

export default {
  name: "InventoryItemsPage",
  components: {
    PharmaceuticalFormTab,
    NonPharmaceuticalFormTab,
    AlertLayout,
  },
  props: {
    show: Boolean,
    prescriptionDetails: Object,
  },
  data() {
    return {
      tabs: [
        { name: "Pharmaceutical Details", component: "PharmaceuticalFormTab" },
        { name: "Non-Pharmaceutical", component: "NonPharmaceuticalFormTab" },
      ],
      currentTab: "PharmaceuticalFormTab",
    };
  },
  methods: {},
};
</script>
